import styled from "styled-components";

import { COLORS, formLabelStyles } from "../../../constants/Styles";

const Container = styled.div`
  ${formLabelStyles};
`;

const Row = styled.div`
  padding: 0.25rem 1rem;
  border-radius: 0.5rem;
  background: ${COLORS.inputGray};
  display: flex;
  align-items: center;

  > input {
    flex: 1;
    display: flex;
    border: none;
    color: ${COLORS.secondary};

    // overriding the autofill styles
    &:-webkit-autofill {
      -webkit-box-shadow: 0 0 0 50px ${COLORS.inputGray} inset;
      -webkit-text-fill-color: ${COLORS.secondary};
    }

    &::placeholder {
      color: ${COLORS.secondaryLight};
    }
  }

  > img {
    cursor: pointer;

    &:hover {
      filter: brightness(150%);
    }
  }
`;

export { Container, Row };
